import { ReactNode } from "react";

import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";
import useTitle from "hooks/useTitle";
import SearchInput from "components/SearchInput";
import { SEARCH_PLACEHOLDERS } from "constants/searchPlaceholders";
import TerraformRegistryViewHeader from "views/Account/TerraformRegistry/ViewHeader";
import SharedModulesTierInfo from "components/TierInfo/SharedModulesTierInfo";
import PageInfoHeader from "ds/components/PageInfoHeader";

import { FILTERS_ORDER_SETTINGS_KEY } from "../../constants";

type SharedModulesPageLayoutProps = {
  children: ReactNode;
};

const SharedModulesPageLayout = ({ children }: SharedModulesPageLayoutProps) => {
  const { accountName } = useTypedContext(AccountContext);

  useTitle(`Shared modules · ${accountName}`);

  return (
    <>
      <TerraformRegistryViewHeader />
      <PageInfoHeader title="Shared modules">
        <SearchInput
          placeholder={SEARCH_PLACEHOLDERS.MODULES}
          filtersOrderSettingsKey={FILTERS_ORDER_SETTINGS_KEY}
        />
      </PageInfoHeader>

      <SharedModulesTierInfo type="callout" />

      {children}
    </>
  );
};

export default SharedModulesPageLayout;
